"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var memoize_1 = tslib_1.__importDefault(require("lodash/memoize"));
var get_label_string_1 = require("./get-label-string");
var intl_format_1 = require("@biw/intl-format");
var getNumberFormatter = memoize_1.default(function (code) { return function (value) { return intl_format_1.formatNumber(code, {}, value); }; });
exports.getBonusMessageHelper = function (code, bonusMQ, bonusMaximumPoints) {
    if (bonusMaximumPoints === void 0) { bonusMaximumPoints = undefined; }
    var _a = tslib_1.__read(code.split('#IF'), 4), msg1 = _a[0], msg2 = _a[1], msg3 = _a[2], msg4 = _a[3];
    var bonusMessage = bonusMQ ? "" + msg1 + msg2 + msg3 : "" + msg1 + msg3;
    return bonusMaximumPoints ? "" + bonusMessage + msg4 : bonusMessage;
};
exports.getBonusReplaceOptions = function (_a) {
    var bonusPayout = _a.bonusPayout, locale = _a.locale, mediaLabel = _a.mediaLabel, bonusPoints = _a.bonusPoints, bonusPrecision = _a.bonusPrecision, bonusRoundingMethod = _a.bonusRoundingMethod;
    if (!bonusPayout) {
        return;
    }
    var intlFormatNumber = getNumberFormatter(locale);
    return {
        mediaLabel: mediaLabel,
        bonusPoints: intlFormatNumber(bonusPoints),
        bonusAward: intlFormatNumber(bonusPayout.bonusAward),
        bonusAchievementAmount: get_label_string_1.getLabelString(bonusPayout.label, bonusPayout.bonusAchievementAmount, bonusPrecision, bonusRoundingMethod, locale),
        bonusIncrementalQuantity: get_label_string_1.getLabelString(bonusPayout.label, bonusPayout.bonusIncrementalQuantity, bonusPrecision, bonusRoundingMethod, locale),
        bonusMaximumPoints: intlFormatNumber(bonusPayout.bonusMaximumPoints),
        bonusMQ: bonusPayout.bonusMQ === null ? '' : get_label_string_1.getLabelString(bonusPayout.label, bonusPayout.bonusMQ, bonusPrecision, bonusRoundingMethod, locale),
        isGoalNeedToAchieve: bonusPayout.isGoalNeedToAchieve,
        isBonusMQ: bonusPayout.bonusMQ !== null ? ', over' : ''
    };
};
exports.getBonusMessage = function (_a) {
    var getString = _a.getString, bonusPayout = _a.bonusPayout, locale = _a.locale, mediaLabel = _a.mediaLabel, bonusPoints = _a.bonusPoints, bonusPrecision = _a.bonusPrecision, bonusRoundingMethod = _a.bonusRoundingMethod;
    if (!bonusPayout) {
        return;
    }
    var bonusReplaceOptions = exports.getBonusReplaceOptions({
        bonusPayout: bonusPayout,
        locale: locale,
        mediaLabel: mediaLabel,
        bonusPoints: bonusPoints,
        bonusPrecision: bonusPrecision,
        bonusRoundingMethod: bonusRoundingMethod
    });
    return exports.getBonusMessageHelper(getString('common.bonus.rateLabelText'), bonusPayout.bonusMQ, bonusPayout.bonusMaximumPoints).template(bonusReplaceOptions);
};
//# sourceMappingURL=get-bonus-message.js.map